export default "__VITE_ASSET__eVv$GU6W__"